import React from 'react';
import Box from '@mui/material/Box';

interface TabPanelProps {
  children: React.ReactNode | null;
  index: number;
  value: number;
}

function CustomTabPanel({ children = null, value, index }: TabPanelProps): React.JSX.Element {
  return (
    <div role="tabpanel" hidden={value !== index} id={`tabPanel-${index}`} aria-labelledby={`tab-${index}`}>
      {value === index && (
        <Box sx={{ p: 3 }} className="md:mx-24 mt-8 max-md:mt-0 pt-0 px-0 pb-0 border-b-[1px]">
          {children}
        </Box>
      )}
    </div>
  );
}

export default CustomTabPanel;
